const nameRegEx = /^[a-zA-Z0-9_.-]*$/;

module.exports = {
  checkLAT(LAT) {
    if (String(LAT) != "NaN") {
      if (LAT < -90 || LAT > 90) return false;
      return true;
    } else return false;
  },
  checkLON(LON) {
    if (LON != "NaN") {
      if (LON < -180 || LON > 180) return false;
      return true;
    } else return false;
  },
  checkIfInputIsNumber(value) {
    let regex = /^[0-9]+$/;
    if (value.match(regex)) {
      return false;
    }
    return true
  },
  testName(name) {
    return !!name && nameRegEx.test(name);
  },
  checkWhiteSpaces(value) {
    return !!value && nameRegEx.test(value);
  },
  notEmpty(value) {
    if (value) return value.trim();
    else return null;
  },
  notRepeatedName(list, name, type, old) {
    let alreadyUsedNames = list || [];
    name = name && name.toUpperCase();
    let exist = alreadyUsedNames.includes(name);
    if (type == "edit") {
      let currently = name == old;
      return currently || !exist;
    } else {
      return !exist;
    }
  },
  checkIfInputIsPercentage(argument){
    return argument>=1 && argument<=100
  },
  checkIfGreaterOrEqual(...args){
    return args[0] >= args[1]
  },
  ok(value=null){
    return{
      isValid:true,
      message:null,
      value:value
    }
  },
  invalid(message){
    return{
      isValid:false,
      message
    }
  },
  isPercentageInput(argument){
    const isPercentage= this.checkIfInputIsPercentage(argument)
    return isPercentage ? this.ok(argument) : this.invalid('é permitido apenas números entre 1 e 100')
  },
  againstZeroInput(argument){
    if(argument>0){
      return this.ok(argument)
    }
    return this.invalid('deve ser superior a 0')
  },
  checkIfDecimalIsGreaterThanLimit(argument){
     const toDecimal = argument+""
     const toArray = toDecimal.split(".")
     const decimalPart = toArray.length && toArray[1]

    if(decimalPart &&  decimalPart.length>3){
      return this.invalid('Não é permitido números com mais de 3 casas decimais')
    }
    return this.ok(argument)
  }

};
